import script from "./_edit-about-me.vue?vue&type=script&setup=true&lang=js"
export * from "./_edit-about-me.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__